import React, { memo, useCallback } from 'react';
import CloseIcon from '@material-ui/icons/Close';
import ResetIcon from 'images/reset.svg';
import { PrimaryButton } from 'components/common/buttons';
import { styles } from './styles';

function ProgramCurrentFilters({
    filters,
    activeFilters,
    setActiveFilters,
}) {
  const classes = styles();

  const handleRemoveFilter = useCallback((filter, filterItem) => {
    setActiveFilters((prevFilters) => {
            const filterIndexToRemove = prevFilters[filter].findIndex(f => f.name === filterItem.name);
      return {
        ...prevFilters,
        [filter]: [
          ...prevFilters[filter].slice(0, filterIndexToRemove),
          ...prevFilters[filter].slice(filterIndexToRemove + 1),
        ],
      };
    });
  }, []);

  const handleClearFilters = useCallback(() => {
    setActiveFilters({});
  }, []);

  return (
    <div className={classes.currentFiltersContainer}>
      <span className={classes.currentFilters}>
                {
                    Object.keys(activeFilters).map(filter => {
                        return [...activeFilters[filter].map(filterItem =>
              <span key={filterItem.name} className={classes.filterChip}>
                <span>{filterItem.name}</span>
                <span
                  className={classes.filterChipCloseIcon}
                  onClick={() => handleRemoveFilter(filter, filterItem)}
                >
                  <CloseIcon />
                </span>
              </span>
                        )];
                    })
                }
      </span>
            {
                Object.keys(activeFilters).some(filter => activeFilters[filter].length > 0) &&
        <span>
          <PrimaryButton
            classes={{ root: classes.btnClearFilters }}
                        startIcon={<img src={ResetIcon} alt='reset' className={classes.iconResetFilter} />}
            onClick={handleClearFilters}
          >
            Clear filters
          </PrimaryButton>
        </span>
            }
        </div>
  );
};

export default memo(ProgramCurrentFilters);
